module.exports = __webpack_public_path__ + "static/media/add sticker-asset3.4aa9e737.png";